import './header.css'
import { FiInfo } from 'react-icons/fi'
import { useLanguage } from '../../i18n/LanguageContext'

export default function SubtitleHeader() {
  const { t } = useLanguage()

  return (
    <p className="subtitle">
      <span className="info-icon-wrapper">
        <span className="info-icon">
          {' '}
          <FiInfo size={20} color="#ffcc80" />
        </span>
        <span className="info-tooltip">
          <li>
            {t('subtitle.tip1')}{' '}
            <span className="highlight-text-italic">
              {t('subtitle.tip1italic')}
            </span>
          </li>
          <li>
            <span className="highlight-text-bold">
              {' '}
              {t('subtitle.tip2Bold')}{' '}
            </span>{' '}
            {t('subtitle.tip2Rest')}
          </li>
          <li>{t('subtitle.tip3')}</li>
          <li>
            {t('subtitle.tip4')}{' '}
            <span className="highlight-text-italic">
              {t('subtitle.tip4italic')}
            </span>
          </li>
        </span>
      </span>
      {t('subtitle.taglinePre')}{' '}
      <span className="highlight">{t('subtitle.comps')}</span>{' '}
      {t('subtitle.taglineMid')}{' '}
      <span className="highlight">{t('subtitle.teammate')}</span>
    </p>
  )
}
